export function getLocalStorageValue(key: string, defaultValue?: string) {
  if (typeof window === 'undefined') {
    return defaultValue;
  }

  return localStorage.getItem(key) ?? defaultValue;
}

export function setLocalStorageValue(key: string, value: string) {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(key, value);
}

export function removeLocalStorageValue(key: string) {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.removeItem(key);
}
